import { render, staticRenderFns } from "./GitConfigDialog.vue?vue&type=template&id=24f1b4b0"
import script from "./GitConfigDialog.vue?vue&type=script&lang=js"
export * from "./GitConfigDialog.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports